import { render, staticRenderFns } from "./PlayState.vue?vue&type=template&id=5e7fe295&scoped=true&"
import script from "./PlayState.vue?vue&type=script&lang=js&"
export * from "./PlayState.vue?vue&type=script&lang=js&"
import style0 from "./PlayState.vue?vue&type=style&index=0&id=5e7fe295&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7fe295",
  null
  
)

export default component.exports